import React from "react";
import { Helmet } from "react-helmet";
import Title from "../../../../Universal/Title.component";

const TuitionHistory = () => {
  return (
    <div className="flex">
      <Helmet>
        <title>Tuition History</title>
      </Helmet>
      <div className="tuitionHistory pb-1" >
        {[...Array(10)].map((_, index) => {
          return (
            <div key={index} className="w-full flex-row align-start justify-between g-05 p-2 back-white radius-6">
              <Title className={"t-18"}>Class 5/A</Title>
              <div className="flex-row align-center justify-start g-1">
                <button
                  className="tuitionHistoryBtn"
                  style={{ "--tuitionHistoryPageBtn": "#FFB700" }}
                >
                  Morning shift
                </button>
                <button
                  className="tuitionHistoryBtn"
                  style={{ "--tuitionHistoryPageBtn": "#867EC6" }}
                >
                  Morning shift
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TuitionHistory;
